export default [
  {
    // Top  2-1
    path: "/TopPages/InnoveDrive",
    name: "InnoveDrive",
    component: () => import("../views/TopPages/InnoveDrive"),
  },
  {
    // Top  2-2
    path: "/TopPages/RdActivity",
    name: "RdActivity",
    component: () => import("../views/TopPages/RdActivity"),
  },
  {
    // Top  3-4
    path: "/TopPages/IUResearch",
    name: "IUResearch",
    component: () => import("../views/TopPages/IUResearch"),
  },
];
